<dt-table-layout *dtDataLoad="true; error: hasError" [isLoading]="isLoading">
  <form header class="filters-form" [formGroup]="filterForm" (ngSubmit)="triggerLoadSubject.next()">
    <mat-form-field class="search-query" subscriptSizing="dynamic">
      <mat-label i18n>Suche</mat-label>
      <input type="text" formControlName="searchQuery" matInput />
      <mat-icon
        matSuffix
        matTooltip="Sucht nach Nutzern mit dem gegebenen Text in Name oder E-Mail. Außerdem kann nach Nutzer ID gesucht werden."
        i18n-matTooltip
        >info</mat-icon
      >
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label i18n>E-Mail bestätigt</mat-label>
      <mat-select formControlName="emailConfirmed">
        <mat-option value="ignore" i18n>Egal</mat-option>
        <mat-option [value]="true" i18n>Ja</mat-option>
        <mat-option [value]="false" i18n>Nein</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label i18n>Rollen</mat-label>
      <mat-select formControlName="roles" multiple>
        @for (role of roles; track role; let i = $index) {
          <mat-option [value]="role">{{ role }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>

  <table
    mat-table
    [dataSource]="items"
    matSort
    [matSortDisableClear]="true"
    [matSortActive]="sort.sortBy"
    [matSortDirection]="sort.sortDirection"
    (matSortChange)="onSortChange($event)"
  >
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</th>
      <td mat-cell *matCellDef="let row">
        @if (!row.name) {
          <i>Kein Name</i>
        }
        {{ row.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>E-Mail-Adresse</th>
      <td mat-cell *matCellDef="let row">{{ row.email }}</td>
    </ng-container>
    <ng-container matColumnDef="emailConfirmed">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>E-Mail bestätigt</th>
      <td mat-cell *matCellDef="let row">
        <mat-icon>{{ row.emailConfirmed ? 'done' : 'close' }}</mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="roles">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Rollen</th>
      <td mat-cell *matCellDef="let row">
        @if (row.roles.length === 0) {
          &mdash;
        }
        <mat-chip-set>
          @for (role of row.roles; track role) {
            <mat-chip>{{ role }}</mat-chip>
          }
        </mat-chip-set>
      </td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Registriert am</th>
      <td mat-cell *matCellDef="let row">{{ row.createdAt | date: 'medium' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="showDetails(row)"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length" i18n>Keine Benutzer entsprechen dem Filter.</td>
    </tr>
  </table>

  <mat-paginator
    [pageSize]="page.pageSize"
    [pageIndex]="page.pageIndex"
    [length]="itemCount"
    [showFirstLastButtons]="true"
    (page)="onPageChange($event)"
  ></mat-paginator>
</dt-table-layout>
